module.exports = __webpack_public_path__ + "img/考古江苏.4866e3a6.png";